import { useQuery } from "@tanstack/react-query";
import dayjs from "dayjs";
import { IClassEvent } from "../../../models/ClassEvent";
import { QUERY_CONSTANTS } from "../../queryKeys";
import { ClassEventService } from "../../../services/class-event.service";

type UseGetClassEventsRangeArgs = {
  gymId: string;
  date?: string;
  userId?: string;
};

export const useGetClassEventsByDateAndGymIdQuery = ({
  gymId,
  date = dayjs().format("YYYY-MM-DD"),
  userId,
}: UseGetClassEventsRangeArgs) => {
  return useQuery<IClassEvent[], Error>({
    queryKey: [QUERY_CONSTANTS.GET_CLASS_EVENTS_BY_DATE_AND_GYM_ID, gymId, date, userId],
    enabled: Boolean(gymId),
    queryFn: () =>
      ClassEventService.getClassEventsByDateAndGymId(
        gymId,
        dayjs(date).format("YYYY-MM-DD"),
        userId
      ).then((res) => res.data),
    staleTime: 60_000,
  });
};
